
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1508',
  depVersions: {
  "customer-portal-app": "static-1.1508",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.442",
  "data-fetching-client": "static-1.9387",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.387",
  "growth-payments-core": "static-1.24484",
  "head-dlb": "static-1.4754",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5302",
  "hs-test-utils": "static-1.7694",
  "hub-http": "static-1.5872",
  "hub-http-shared-msw-handlers": "static-1.9240",
  "hubspot-dlb": "static-2.1786",
  "hubspot-prosemirror": "static-1.17374",
  "hubspot-url-utils": "static-1.3873",
  "HubStyleTokens": "static-2.11135",
  "I18n": "static-7.1545",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6166",
  "payment-link-components": "static-1.22684",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6595",
  "quartz-core": "static-1.5814",
  "react": "static-7.176",
  "react-colorpicker": "static-2.9924",
  "react-dlb": "static-1.70",
  "react-utils": "static-2.5095",
  "rich-text-lib": "static-1.19311",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17433",
  "ui-components-test-utils": "static-1.5273",
  "UIComponents": "static-3.8082",
  "foundations-assets": "static-1.4543",
  "foundations-components": "static-1.7337",
  "foundations-theming": "static-1.4115",
  "foundations-theming-specialty": "static-1.1831",
  "framer-motion": "static-1.66",
  "history": "static-4.47",
  "metrics-js": "static-1.9346",
  "PortalIdParser": "static-2.349",
  "portals-platform-lib": "static-1.440",
  "quartz-config": "static-1.373",
  "quick-fetch": "static-1.3648",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16344",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7851",
  "styled-components": "static-2.84",
  "tanstack-table": "static-1.49",
  "ui-addon-draggable": "static-3.4456",
  "ui-addon-react-router-dom": "static-1.9258",
  "usage-tracker": "static-1.7047",
  "usage-tracker-anonymous": "static-1.5464",
  "usage-tracker-core": "static-1.6897",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3148",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2872",
  "quartz-webpack": "static-1.2819",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "commerce-analytics-service-client": "static-1.3400",
  "customer-data-objects": "static-1.7324",
  "frontend-preferences-client": "static-1.7635",
  "laboratory-lib": "static-3.6855",
  "onboarding-scopes": "static-1.6154",
  "rpc-client-utils": "static-1.4318",
  "ui-addon-opt": "static-4.8100",
  "HeadJS": "static-2.693",
  "hs-test-utils-bend-plugin": "static-1.2805",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3823",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7320",
  "cssUtils": "static-1.704",
  "customer-data-ui-utilities": "static-1.9537",
  "HubStyle": "static-2.11443",
  "knowledge-content-types": "static-1.8277",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.270",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.482",
  "ui-addon-emoji-picker": "static-1.9601",
  "ui-addon-i18n": "static-1.10840",
  "ui-business-units-lib": "static-1.8733",
  "ui-shepherd-react": "static-3.9855",
  "video-components-external": "static-1.10294",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4043",
  "commerce-tours-lib": "static-1.5577",
  "customer-data-properties": "static-1.50522",
  "getting-started-shared-tasks": "static-1.17631",
  "growth-onboarding-reliability": "static-1.4799",
  "onboarding-tours": "static-1.16149",
  "reference-resolvers-lite": "static-1.7801",
  "sales-checkout-service-client": "static-1.3412",
  "ui-addon-iframeable": "static-1.8730",
  "user-context": "static-1.4806",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.774",
  "hubspotter-http": "static-1.4397",
  "icons": "static-2.614",
  "mobile-manifest-mixins": "static-1.466",
  "quartz-auth": "static-1.270",
  "quartz-head": "static-1.260",
  "quartz-test": "static-1.270",
  "usage-tracker-container": "static-1.7037",
  "ui-fonts": "static-1.397",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9138",
  "data-token-picker": "static-1.15908",
  "FileManagerLib": "static-1.38283",
  "property-translator": "static-1.5125",
  "atom": "static-1.4783",
  "merchandise-lib": "static-1.255",
  "purchase-motions-components": "static-1.5345",
  "salesImages": "static-1.519",
  "self-service-api": "static-1.9937",
  "SharedI18nStrings": "static-1.179",
  "upgrade-management-service-types": "static-1.4219",
  "foundations-components-test-utils": "static-1.4820",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "ui-images": "static-2.1065",
  "bend-plugin-foundations-components": "static-1.3606",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "trellis-assets": "static-1.996",
  "bend-plugin-foundations-theming": "static-1.2598",
  "foundations-theming-base": "static-1.3100",
  "stylex": "static-1.26",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4186",
  "react-flip-move": "static-1.64",
  "bender-build-tools": "static-1.2823",
  "inbound-db-properties-service-client": "static-1.3598",
  "superstore": "static-1.4484",
  "feedback-loader": "static-1.28697",
  "ai-components-ui-library": "static-1.8122",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27706",
  "sassPrefix": "static-1.150",
  "react-dnd-compat": "static-1.4335",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2177",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7873",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4360",
  "content-media-composition-data-lib": "static-1.11096",
  "content-media-compositions": "static-2.15103",
  "idb-keyval": "static-1.38",
  "immer": "static-1.33",
  "immerable": "static-1.3867",
  "magpie-lib": "static-1.5287",
  "magpie-types": "static-1.4747",
  "media-bridge-lib": "static-1.18429",
  "video-data-lib": "static-1.33952",
  "commerce-products-lib": "static-1.8585",
  "crm-message-bus": "static-1.42136",
  "growth-data-modal": "static-1.5044",
  "hubspot-apollo-client": "static-1.4591",
  "onboarding-tours-client": "static-1.4363",
  "calling-global-api": "static-1.63375",
  "calling-internal-common": "static-1.31000",
  "calling-lifecycle-internal": "static-1.64757",
  "calling-lifecycle-messages": "static-1.57051",
  "conditional-properties-service-client": "static-1.3542",
  "crm-links": "static-1.5963",
  "customer-data-objects-ui-components": "static-1.12713",
  "customer-data-property-utils": "static-1.7781",
  "external-options-client-types": "static-1.3902",
  "file-manager-components": "static-1.22643",
  "framework-data-schema-resolvers": "static-1.6581",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.370",
  "inbound-db-meta-service-client": "static-1.3379",
  "inbounddb-objects-service-types": "static-1.3969",
  "meetings-icalendar-utils-lib": "static-1.345",
  "multi-currency-client-types": "static-1.3440",
  "object-builder-ui-client": "static-1.47694",
  "pipeline-validation-client-types": "static-1.3706",
  "property-value-citations": "static-1.1136",
  "pulse": "static-1.207",
  "smart-property-lib": "static-1.5580",
  "tiered-pricing": "static-1.684",
  "ui-addon-form-validation": "static-1.10707",
  "growth-onboarding-confetti": "static-1.2762",
  "growth-onboarding-next-action-utils": "static-1.1206",
  "navigation-components": "static-1.17018",
  "onboarding-tours-utils": "static-1.215",
  "ui-shepherd-tracker": "static-1.7236",
  "ui-universal-auth": "static-1.8577",
  "batch-promise": "static-1.1241",
  "navigation-messaging": "static-1.6345",
  "getting-started-shared-tasks-store": "static-1.16749",
  "hubspotter-http-shared-msw-handlers": "static-1.9238",
  "audio-components": "static-1.5484",
  "FileManagerCore": "static-1.38142",
  "FileManagerImages": "static-1.35794",
  "video-components": "static-1.12297",
  "growth-monetization-service-types": "static-1.4235",
  "nav-client-types": "static-1.2044",
  "purchase-motions-api": "static-1.5348",
  "signup-constants": "static-1.18227",
  "signup-ui-url-generator": "static-2.7743",
  "trials-service-types": "static-1.3636",
  "chatspot-core": "static-1.20011",
  "chirp-fetch": "static-1.1593",
  "ContentUtils": "static-1.67361",
  "copilot-toolkit": "static-1.10314",
  "growth-onboarding-feedback-components": "static-1.6297",
  "hls.js": "static-1.33",
  "reactive-lib": "static-1.437",
  "simple-logging-lib": "static-1.2762",
  "customer-data-tracking": "static-1.6573",
  "products-iframe-lib": "static-1.7104",
  "products-ui-components-shared-msw-handlers": "static-1.9622",
  "hubspot-apollo-cache": "static-1.50",
  "calling-error-reporting": "static-1.31006",
  "shared-worker-versioning": "static-1.10728",
  "calling-usage-tracker": "static-1.6250",
  "calling-orchestration-shared-library": "static-1.34539",
  "conversations-skeleton-state": "static-1.6962",
  "location-customization-utils-lib": "static-1.8279",
  "crm-pipelines-api-client-types": "static-1.3884",
  "framework-builder-read-service-client": "static-1.3766",
  "framework-data-schema-quick-fetch": "static-1.6486",
  "persist-promise": "static-1.3398",
  "directed-graph": "static-1.649",
  "event-emitter": "static-1.636",
  "breeze-intelligence-kit": "static-1.5189",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9323",
  "fsm": "static-1.3442",
  "policy-lib": "static-1.6513",
  "react-tinymce": "static-1.54388",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9386",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53514",
  "tinymce-plugins": "static-1.56628",
  "tinymce-themes": "static-1.55484",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4246",
  "video-embed": "static-1.34786",
  "content-icons-ui": "static-1.2123",
  "social-insights-client-types": "static-1.21128",
  "eligibility-engine-service-types": "static-1.2917",
  "chatspot-client-types": "static-1.10365",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4519",
  "integrations-lib": "static-1.15134",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4004",
  "calling-orchestration-schema": "static-1.34764",
  "crm-record-cards-service-types": "static-1.3371",
  "highcharts": "static-8.98",
  "trellis-story-utils": "static-1.4234",
  "storybook-react": "static-1.27",
  "hub-http-contrib": "static-1.2757",
  "interframe": "static-3.4504",
  "tinymce-data": "static-1.39599",
  "ui-addon-sales-email": "static-1.4925",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11881",
  "layout-dnd-utils": "static-1.10856",
  "react-codemirror": "static-1.10316",
  "ui-brand-identity-lib": "static-1.13463",
  "NamespacedHubStyle": "static-2.8818",
  "outpost": "static-1.3923",
  "cohere-reconnect-lib": "static-1.80",
  "flux-actions": "static-1.298",
  "gemini-reconnect-lib": "static-1.38",
  "integrations-error-boundary-lib": "static-1.12549",
  "integrations-tracking-lib": "static-1.5295",
  "native-integrations-shared-strings": "static-1.7500",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10084",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67436",
  "layout-data-lib": "static-1.9181",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2708",
  "advanced-menus-core": "static-1.14670",
  "advanced-menus-lib": "static-1.11661",
  "ExportDialog": "static-6.10099",
  "ui-memberships-settings-lib": "static-1.33191",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14669",
  "simple-menus-lib": "static-1.16186"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1508",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.442",
  "data-fetching-client": "/data-fetching-client/static-1.9387",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.387",
  "growth-payments-core": "/growth-payments-core/static-1.24484",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5302",
  "hs-test-utils": "/hs-test-utils/static-1.7694",
  "hub-http": "/hub-http/static-1.5872",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9240",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17374",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyleTokens": "/HubStyleTokens/static-2.11135",
  "I18n": "/I18n/static-7.1545",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6166",
  "payment-link-components": "/payment-link-components/static-1.22684",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6595",
  "quartz-core": "/quartz-core/static-1.5814",
  "react": "/react/static-7.176",
  "react-colorpicker": "/react-colorpicker/static-2.9924",
  "react-dlb": "/react-dlb/static-1.70",
  "react-utils": "/react-utils/static-2.5095",
  "rich-text-lib": "/rich-text-lib/static-1.19311",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17433",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5273",
  "UIComponents": "/UIComponents/static-3.8082",
  "foundations-assets": "/foundations-assets/static-1.4543",
  "foundations-components": "/foundations-components/static-1.7337",
  "foundations-theming": "/foundations-theming/static-1.4115",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1831",
  "framer-motion": "/framer-motion/static-1.66",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9346",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "portals-platform-lib": "/portals-platform-lib/static-1.440",
  "quartz-config": "/quartz-config/static-1.373",
  "quick-fetch": "/quick-fetch/static-1.3648",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16344",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7851",
  "styled-components": "/styled-components/static-2.84",
  "tanstack-table": "/tanstack-table/static-1.49",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4456",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9258",
  "usage-tracker": "/usage-tracker/static-1.7047",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5464",
  "usage-tracker-core": "/usage-tracker-core/static-1.6897",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3148",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2872",
  "quartz-webpack": "/quartz-webpack/static-1.2819",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3400",
  "customer-data-objects": "/customer-data-objects/static-1.7324",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7635",
  "laboratory-lib": "/laboratory-lib/static-3.6855",
  "onboarding-scopes": "/onboarding-scopes/static-1.6154",
  "rpc-client-utils": "/rpc-client-utils/static-1.4318",
  "ui-addon-opt": "/ui-addon-opt/static-4.8100",
  "HeadJS": "/HeadJS/static-2.693",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2805",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3823",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7320",
  "cssUtils": "/cssUtils/static-1.704",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9537",
  "HubStyle": "/HubStyle/static-2.11443",
  "knowledge-content-types": "/knowledge-content-types/static-1.8277",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.270",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9601",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10840",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8733",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9855",
  "video-components-external": "/video-components-external/static-1.10294",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4043",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5577",
  "customer-data-properties": "/customer-data-properties/static-1.50522",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17631",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4799",
  "onboarding-tours": "/onboarding-tours/static-1.16149",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7801",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3412",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8730",
  "user-context": "/user-context/static-1.4806",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.774",
  "hubspotter-http": "/hubspotter-http/static-1.4397",
  "icons": "/icons/static-2.614",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.466",
  "quartz-auth": "/quartz-auth/static-1.270",
  "quartz-head": "/quartz-head/static-1.260",
  "quartz-test": "/quartz-test/static-1.270",
  "usage-tracker-container": "/usage-tracker-container/static-1.7037",
  "ui-fonts": "/ui-fonts/static-1.397",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9138",
  "data-token-picker": "/data-token-picker/static-1.15908",
  "FileManagerLib": "/FileManagerLib/static-1.38283",
  "property-translator": "/property-translator/static-1.5125",
  "atom": "/atom/static-1.4783",
  "merchandise-lib": "/merchandise-lib/static-1.255",
  "purchase-motions-components": "/purchase-motions-components/static-1.5345",
  "salesImages": "/salesImages/static-1.519",
  "self-service-api": "/self-service-api/static-1.9937",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4219",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4820",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "ui-images": "/ui-images/static-2.1065",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3606",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "trellis-assets": "/trellis-assets/static-1.996",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2598",
  "foundations-theming-base": "/foundations-theming-base/static-1.3100",
  "stylex": "/stylex/static-1.26",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4186",
  "react-flip-move": "/react-flip-move/static-1.64",
  "bender-build-tools": "/bender-build-tools/static-1.2823",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3598",
  "superstore": "/superstore/static-1.4484",
  "feedback-loader": "/feedback-loader/static-1.28697",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8122",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27706",
  "sassPrefix": "/sassPrefix/static-1.150",
  "react-dnd-compat": "/react-dnd-compat/static-1.4335",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2177",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7873",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4360",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11096",
  "content-media-compositions": "/content-media-compositions/static-2.15103",
  "idb-keyval": "/idb-keyval/static-1.38",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3867",
  "magpie-lib": "/magpie-lib/static-1.5287",
  "magpie-types": "/magpie-types/static-1.4747",
  "media-bridge-lib": "/media-bridge-lib/static-1.18429",
  "video-data-lib": "/video-data-lib/static-1.33952",
  "commerce-products-lib": "/commerce-products-lib/static-1.8585",
  "crm-message-bus": "/crm-message-bus/static-1.42136",
  "growth-data-modal": "/growth-data-modal/static-1.5044",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4591",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4363",
  "calling-global-api": "/calling-global-api/static-1.63375",
  "calling-internal-common": "/calling-internal-common/static-1.31000",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64757",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57051",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3542",
  "crm-links": "/crm-links/static-1.5963",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12713",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7781",
  "external-options-client-types": "/external-options-client-types/static-1.3902",
  "file-manager-components": "/file-manager-components/static-1.22643",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6581",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.370",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3379",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3969",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.345",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3440",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47694",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3706",
  "property-value-citations": "/property-value-citations/static-1.1136",
  "pulse": "/pulse/static-1.207",
  "smart-property-lib": "/smart-property-lib/static-1.5580",
  "tiered-pricing": "/tiered-pricing/static-1.684",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10707",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2762",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1206",
  "navigation-components": "/navigation-components/static-1.17018",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.215",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7236",
  "ui-universal-auth": "/ui-universal-auth/static-1.8577",
  "batch-promise": "/batch-promise/static-1.1241",
  "navigation-messaging": "/navigation-messaging/static-1.6345",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16749",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9238",
  "audio-components": "/audio-components/static-1.5484",
  "FileManagerCore": "/FileManagerCore/static-1.38142",
  "FileManagerImages": "/FileManagerImages/static-1.35794",
  "video-components": "/video-components/static-1.12297",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4235",
  "nav-client-types": "/nav-client-types/static-1.2044",
  "purchase-motions-api": "/purchase-motions-api/static-1.5348",
  "signup-constants": "/signup-constants/static-1.18227",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7743",
  "trials-service-types": "/trials-service-types/static-1.3636",
  "chatspot-core": "/chatspot-core/static-1.20011",
  "chirp-fetch": "/chirp-fetch/static-1.1593",
  "ContentUtils": "/ContentUtils/static-1.67361",
  "copilot-toolkit": "/copilot-toolkit/static-1.10314",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6297",
  "hls.js": "/hls.js/static-1.33",
  "reactive-lib": "/reactive-lib/static-1.437",
  "simple-logging-lib": "/simple-logging-lib/static-1.2762",
  "customer-data-tracking": "/customer-data-tracking/static-1.6573",
  "products-iframe-lib": "/products-iframe-lib/static-1.7104",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9622",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.50",
  "calling-error-reporting": "/calling-error-reporting/static-1.31006",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10728",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6250",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34539",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6962",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8279",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3884",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3766",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6486",
  "persist-promise": "/persist-promise/static-1.3398",
  "directed-graph": "/directed-graph/static-1.649",
  "event-emitter": "/event-emitter/static-1.636",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5189",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9323",
  "fsm": "/fsm/static-1.3442",
  "policy-lib": "/policy-lib/static-1.6513",
  "react-tinymce": "/react-tinymce/static-1.54388",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9386",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53514",
  "tinymce-plugins": "/tinymce-plugins/static-1.56628",
  "tinymce-themes": "/tinymce-themes/static-1.55484",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4246",
  "video-embed": "/video-embed/static-1.34786",
  "content-icons-ui": "/content-icons-ui/static-1.2123",
  "social-insights-client-types": "/social-insights-client-types/static-1.21128",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2917",
  "chatspot-client-types": "/chatspot-client-types/static-1.10365",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4519",
  "integrations-lib": "/integrations-lib/static-1.15134",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4004",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34764",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3371",
  "highcharts": "/highcharts/static-8.98",
  "trellis-story-utils": "/trellis-story-utils/static-1.4234",
  "storybook-react": "/storybook-react/static-1.27",
  "hub-http-contrib": "/hub-http-contrib/static-1.2757",
  "interframe": "/interframe/static-3.4504",
  "tinymce-data": "/tinymce-data/static-1.39599",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4925",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11881",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10856",
  "react-codemirror": "/react-codemirror/static-1.10316",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13463",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8818",
  "outpost": "/outpost/static-1.3923",
  "cohere-reconnect-lib": "/cohere-reconnect-lib/static-1.80",
  "flux-actions": "/flux-actions/static-1.298",
  "gemini-reconnect-lib": "/gemini-reconnect-lib/static-1.38",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12549",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5295",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7500",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10084",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67436",
  "layout-data-lib": "/layout-data-lib/static-1.9181",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2708",
  "advanced-menus-core": "/advanced-menus-core/static-1.14670",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11661",
  "ExportDialog": "/ExportDialog/static-6.10099",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33191",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14669",
  "simple-menus-lib": "/simple-menus-lib/static-1.16186"
}
};
